import { render, staticRenderFns } from "./Oferta.vue?vue&type=template&id=6893351c&scoped=true&"
import script from "./Oferta.ts?vue&type=script&lang=ts&"
export * from "./Oferta.ts?vue&type=script&lang=ts&"
import style0 from "./Oferta.vue?vue&type=style&index=0&id=6893351c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6893351c",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QImg});
